<dx-date-range-box
  class="date-range-box"
  [startDateLabel]="startDateLabel()"
  [endDateLabel]="endDateLabel()"
  [showClearButton]="true"
  (onValueChanged)="onValueChanged($event)"
  [(value)]="selectedDates"
  [displayFormat]="DateLevelFormat[selectLevel]"
  [calendarOptions]="DateLevelZoom[selectLevel]">
</dx-date-range-box>
